import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S38NearbyLocationsSection } from '../components/interactive-sections/S38NearbyLocations';
import { getBackgroundColorInput, getPaddingInputs } from '../utils/builderSharedInputs';
import { altBackgroundColorOptions } from '../utils/builderColorOptions';

Builder.registerComponent(S38NearbyLocationsSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S38NearbyLocations,
    friendlyName: 'S38 Nearby Locations',
    models: ['clinic-page'],
    inputs: [
        {
            name: 'mapIcon',
            type: 'file',
            friendlyName: 'Map Pin Icon',
            helperText: 'Map Pin icon',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fe8cc0ff7a853473ebecdc56459f7fe11',
        },
        {
            name: 'phoneIcon',
            type: 'file',
            friendlyName: 'Phone Icon',
            helperText: 'Phone icon image',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fe8cc0ff7a853473ebecdc56459f7fe11',
        },
        ...getPaddingInputs(),
        ...getBackgroundColorInput({
            defaultValue: 'Turquoise20',
            backgroundColorsList: altBackgroundColorOptions,
        }),
    ],
});
